<template>

    <div style="background: red;">
        zxc
<!--        <h2 v-t="'Home.title'"></h2>-->
        <!--        {{ $t("Home.title") }}-->
<!--                {{ $t("hello") }}-->
        <!--    <v-btn-->
        <!--            color="red lighten-2"-->
        <!--            dark-->
        <!--            v-on="on">-->
        <!--        asdqwe-->
        <!--    </v-btn>-->
        <div>{{counter}}</div>
        <v-btn
                color="success"
                v-on:click="qweasd"
        >scounter;
        </v-btn>
        <div v-if="signedIn === false">
            signed out
<!--            <amplify-authenticator></amplify-authenticator>-->
        </div>
        <div v-if="signedIn">
<!--            <amplify-sign-out :signOutConfig="{msg: 'You are currently signed in.',signOutButton: 'Sign Out yo!'}"></amplify-sign-out>-->
            signed in

<!--            <amplify-sign-out class="signout" v-bind:signOutOptions="signOutOptions"></amplify-sign-out>-->
<!--            <img alt="Vue logo" src="./assets/logo.png">-->
<!--            <HelloWorld msg="Welcome to Your Vue.js App"/>-->
<!--            &lt;!&ndash; <button v-on:click="signOut">Sign Out</button> &ndash;&gt;-->
        </div>
    </div>
</template>

<script>

  import { Auth, Hub, } from 'aws-amplify';
  // import i18n from '@/i18n'

  export default {
    name: 'UserButton',
    async beforeCreate() {
      // console.log('beforeCreate 1:', this);
      // console.log('beforeCreate 2:', i18n);
      try {
        const user = await Auth.currentAuthenticatedUser()
        this.signedIn = true
      } catch (err) {
        this.signedIn = false
      }
      // AmplifyEventBus.$on('authState', info => {
      //   if (info === 'signedIn') {
      //     this.signedIn = true
      //   } else {
      //     this.signedIn = false
      //   }
      // });
      // console.log('beforeCreate 1', this.onAuth);
      Hub.listen('auth', this.onAuth);
    },
    created () {
      // console.log('created ', this)

      // Hub.listen('auth', (data) => {
      //   const { payload } = data;
      //   console.log('A new auth event has happened: ', data.payload.data.username + ' has ' + data.payload.event);
      // })
      // AmplifyEventBus.$on('authState', info => {
      //   console.log(`Here is the auth event that was just emitted by an Amplify component: ${info}`)
      // });
    },
    mounted () {
      console.log('mounted ');
    },
    beforeDestroy() {
      // Hub.remove('auth', this.onAuth);
      console.log('beforeDestroy ');
      Hub.remove('auth', this.onAuth);
    },
    data () {
      return {
        signedIn: false,
        counter: 0,
      }
    },
    methods: {
      async onAuth(data) {
        // console.log('A new auth event has happened: 1 ', data.payload.data.username + ' has ' + data.payload.event);
        console.log('A new auth event has happened: 2 ', data.payload);
        await Auth.currentAuthenticatedUser()
          .then(() => this.signedIn = true)
          .catch(() => this.signedIn = false);
      },
      qweasd: function (event) {
        console.log('qweasd event:', event)
        console.log('qweasd :', this)
        console.log('qweasd :', this.$http)
        this.counter++
        // Auth.currentSession()
        //   .then(data => {
        //     console.log(data)
        //
        //     this.$http({
        //       method: 'post', // you can set what request you want to be
        //       url: 'https://b2mmnijy50.execute-api.ap-northeast-2.amazonaws.com/default/wework-lambda-debug-20190618',
        //       data: {
        //         'c': 'console.log("asd");',
        //         'query': 'SELECT * FROM `table_name` ORDER BY column_1 DESC LIMIT 50',
        //         'params': [Math.random() * 10000],
        //         'greeter': 'asd',
        //       },
        //       headers: {
        //         'x-api-key': 'FzNOh8Zswn8vt0gJ8Rm8g6daOifpYrlz1EdrSYVM',
        //         'Content-Type': 'application/json',
        //         'Authorization': data.idToken.jwtToken,
        //       }
        //     })
        //     .then(function (response) {
        //       // response.data.pipe(fs.createWriteStream('ada_lovelace.jpg'))
        //       console.log('response:', response)
        //       response.data.results.forEach(function (element) {
        //         console.log(element)
        //       })
        //     })
        // })
        // .catch(err => console.log(err))
      },
      test33: function (event) {

      },
    },
  }
</script>

<style scoped>

</style>
